import {
  // ActiveMonitorIcon,
  ClientsIcon,
  ClientsIconPrimary500,
  DashboardIcon,
  DashboardIconPrimary500,
  NewsAlertsIcon,
  NewsAlertsIconPrimary500,
  // NormalMonitorIcon,
  RolesIcon,
  HelpIcon,
  TeamsIcon,
  ActiveMonitorIcon,
  NormalMonitorIcon,
} from "../../../theme/icons";
import {
  OverviewIcon, BookIcon, LayerIcon, CPUIcon,
  CardIcon,
  DollarIcon
} from "../../../theme/icons2";
import { globalRoles } from "../../../utils/globalRoles";

export const sidebarMenus = [
  {
    title: "Dashboard",
    path: "/dashboard",
    icon: <DashboardIcon />,
    activeIcon: <DashboardIconPrimary500 />,
    children: [],
    permissions: ["*"],
    badge: "",
    region: ["Other", "India"],
  },
  {
    title: "Teams",
    path: "/teams",
    icon: <TeamsIcon />,
    activeIcon: <TeamsIcon stroke="#3753B8" />,
    children: [],
    permissions: [
      globalRoles.admin,
      globalRoles.superAdmin,
      globalRoles.manager,
    ],
    badge: "",
    region: ["Other", "India"],
  },

  {
    title: "Clients",
    path: "/not-found",
    icon: <ClientsIcon />,
    activeIcon: <ClientsIconPrimary500 />,
    permissions: ["*"],
    badge: "",
    region: ["Other", "India"],
    children: [
      {
        title: "Manage Clients",
        path: "/clients",
        children: [],
        permissions: ["*"],
        region: ["Other", "India"],
      },
      {
        title: "Payroll Scheduler",
        path: "/manage-sla",
        children: [],
        permissions: ["*"],
        region: ["Other", "India"],
      },
      {
        title: "Invoices",
        path: "/invoice-hub",
        children: [],
        permissions: [globalRoles.admin, globalRoles.superAdmin],
        region: ["Other", "India"],
      },
    ],
  },
  {
    title: "Payroll Overview",
    path: "/payroll-overview",
    children: [],
    permissions: ["*"],
    icon: <LayerIcon />,
    activeIcon: <LayerIcon stroke="#3753B8" />,
    badge: "",
    region: ["Other", "India"],
  },
  {
    title: "POI Overview ",
    path: "/poi-overview",
    icon: <BookIcon />,
    activeIcon: <BookIcon stroke="#3753B8" />,
    children: [],
    permissions: ["*"],
    badge: "",
    region: ["India"],
  },
  {
    title: "FBP Overview",
    path: "/fbp-overview",
    icon: <CPUIcon />,
    activeIcon: <CPUIcon stroke="#3753B8" />,
    children: [],
    permissions: ["*"],
    badge: "",
    region: ["India"],
  },
  {
    title: "Reimbursement Overview ",
    path: "/re-imbursements",
    icon: <DollarIcon />,
    activeIcon: <DollarIcon stroke="#3753B8" />,
    children: [],
    permissions: ["*"],
    badge: "",
    region: ["Other", "India"],
  },
  {
    title: "PAN Status Overview",
    path: "/pan-status",
    icon: <CardIcon />,
    activeIcon: <CardIcon stroke="#3753B8" />,
    children: [],
    permissions: ['*'],
    badge: "",
    region: ["India"],
  },
  {
    title: " IT Declaration Overview",
    path: "/it-management",
    children: [],
    permissions: ["*"],
    icon: <NormalMonitorIcon />,
    activeIcon: <ActiveMonitorIcon />,
    badge: "",
    region: ["India"],
  },
  {
    title: "Help Desk Overview",
    path: "/help-desk",
    icon: <HelpIcon />,
    activeIcon: <HelpIcon stroke="#3753B8" />,
    children: [],
    permissions: ["*"],
    badge: "",
    region: ["Other", "India"],
  },
  {
    title: "Workcenter",
    path: "/workcenter",
    icon: <ClientsIcon />,
    activeIcon: <ClientsIconPrimary500 />,
    children: [],
    permissions: ["*"],
    badge: "",
    region: ["Other", "India"],
  },
  {
    title: "greytHR Roles Sync",
    path: "/roles",
    icon: <RolesIcon />,
    activeIcon: <RolesIcon stroke="#3753B8" />,
    children: [],
    permissions: [globalRoles.admin, globalRoles.superAdmin],
    badge: "",
    region: ["Other", "India"],
  },
  

  {
    title: "News and Alerts",
    path: "/news-alerts",
    icon: <NewsAlertsIcon />,
    activeIcon: <NewsAlertsIconPrimary500 />,
    children: [],
    permissions: ["*"],
    badge: "",
    region: ["India"],
  },
  {
    title: "Overview",
    path: "/overview",
    icon: <OverviewIcon />,
    activeIcon: <OverviewIcon />,
    badge: "Upcoming",
    children: [
      {
        title: "Tasks",
        path: "/tasks",
        children: [],
        permissions: [globalRoles.admin, globalRoles.superAdmin],
        region: ["Other", "India"],
      },
    ],
    permissions: [globalRoles.admin, globalRoles.superAdmin],
    region: ["Other", "India"],
  },
];
